import React, { FC } from 'react';
import { PatientImportResultDto } from '@docbay/schemas';
import { Wrapper, WrapperItem, PatientInfo, PatientList } from './styles';
import { useTranslation } from 'react-i18next';
import { ReactComponent as CheckCircleIcon } from 'applicaiton/assets/check-circle.svg';

interface Props {
  data: PatientImportResultDto[];
}

const SavedPatients: FC<Props> = ({ data }) => {
  const { t } = useTranslation();

  return (
    <Wrapper>
      <p>
        {data.length} {t('patient.contacts_imported')}
      </p>
      <PatientList>
        {data.map((item, index) => {
          return (
            <WrapperItem
              key={`saved_${item.patient.socialSecurityNumber}`}
              className={'saved'}
            >
              <div>
                <CheckCircleIcon />
                <PatientInfo>
                  <p>
                    {index + 1}. {item.patient.firstName}{' '}
                    {item.patient.lastName}
                  </p>
                  <span>{item.patient.phone}</span>
                </PatientInfo>
              </div>
              <div>{t('patient.tab_imported')}</div>
            </WrapperItem>
          );
        })}
      </PatientList>
    </Wrapper>
  );
};

export default SavedPatients;
